export default "__VITE_ASSET__psZod4ZE__"